import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

export class OpsRouteReuseStrategy extends BaseRouteReuseStrategy {
    override shouldReuseRoute(
        future: ActivatedRouteSnapshot,
        curr: ActivatedRouteSnapshot,
    ): boolean {
        return (
            super.shouldReuseRoute(future, curr) ||
            future.routeConfig.component == curr.routeConfig.component
        ); // || future.data.reuseComponent;
    }
}
